import { useEffect, useRef, useState } from "react";
import { NotePencil } from "@phosphor-icons/react";

export default function InlineNotes({ value, onSave, providerId }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(value || "");
    const ref = useRef(null);

    useEffect(() => {
        setDraft(value || "");
    }, [value]);

    useEffect(() => {
        if (editing && ref.current) ref.current.focus();
    }, [editing]);

    const save = async () => {
        const next = draft.trim();
        setEditing(false);
        if (next !== (value || "")) {
            await onSave?.(next);
        }
    };

    if (!editing) {
        return (
            <button
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setEditing(true);
                }}
                className="group inline-flex items-start gap-1 text-left text-[11px] text-[#52525b] hover:text-black w-full"
                data-testid={`notes-open-${providerId}`}
            >
                <NotePencil
                    size={12}
                    weight="bold"
                    className="shrink-0 mt-[2px] text-[#a1a1aa] group-hover:text-black"
                />
                <span className="italic break-words">
                    {value ? value : "Add note…"}
                </span>
            </button>
        );
    }

    return (
        <div
            className="flex flex-col gap-1 w-full"
            onClick={(e) => e.stopPropagation()}
        >
            <textarea
                ref={ref}
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                onBlur={save}
                rows={2}
                maxLength={1000}
                className="brutal-input p-2 text-[11px] w-full"
                placeholder="e.g. asked to call Tuesday; prefers WhatsApp"
                data-testid={`notes-textarea-${providerId}`}
            />
            <div className="flex justify-end gap-2 text-[10px]">
                <button
                    type="button"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                        setDraft(value || "");
                        setEditing(false);
                    }}
                    className="btn-ghost"
                    data-testid={`notes-cancel-${providerId}`}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={save}
                    className="mono"
                    style={{
                        border: "1px solid #000",
                        padding: "2px 8px",
                        background: "#000",
                        color: "#fff",
                    }}
                    data-testid={`notes-save-${providerId}`}
                >
                    Save
                </button>
            </div>
        </div>
    );
}
